import { Box, Button, Divider, IconButton, Modal } from "@mui/material";
import { IMainModal } from "./MainModalInterfaces";
import { useTranslation } from "react-i18next";
import { modalStyles, useStyles } from "./MainModal.styles";
import CloseIcon from "@mui/icons-material/Close";

const MainModal = ({
    isOpen,
    onClose,
    title,
    showCloseButton,
    children,
    cancelButton,
    okButton,
    disableCancelButton,
    disableOkButton,
    showFooterDivider = true,
    showFooter = true,
    showHeaderDivider = true,
    showHeader = true,
    onCancelButtonClick,
    onOkButtonClick,
    customModalStyles,
    disableEscapeKeyDown = true,
    keepMounted = false,
    contentClassName,
    footer,
    okButtonColor,
}: IMainModal) => {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <Modal
            open={isOpen}
            onClose={(event: MouseEvent) => {
                event?.stopPropagation();
                onClose();
            }}
            disableEscapeKeyDown={disableEscapeKeyDown}
            keepMounted={keepMounted}
        >
            <Box
                onClick={(event) => {
                    event.stopPropagation();
                }}
                sx={{ ...modalStyles, ...customModalStyles }}
            >
                {showHeader && (
                    <>
                        <div className={classes.header}>
                            {title && <div className={classes.headerTitle}>{title}</div>}
                            {!!showCloseButton && (
                                <div className={classes.headerActions}>
                                    <IconButton
                                        aria-label="delete"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onClose();
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                            )}
                        </div>
                        {showHeaderDivider && <Divider />}
                    </>
                )}

                <div className={contentClassName}>{children}</div>
                {showFooter && !footer && (
                    <>
                        {showFooterDivider && <Divider className={classes.footerDivider} />}
                        <div className={classes.footer}>
                            <Button
                                variant="text"
                                color="info"
                                className={classes.button}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (onCancelButtonClick) {
                                        onCancelButtonClick();
                                    } else {
                                        onClose();
                                    }
                                }}
                                disabled={disableCancelButton}
                            >
                                {cancelButton || t("main_modal.cancel_button")}
                            </Button>
                            <Button
                                variant="contained"
                                color={okButtonColor || "info"}
                                className={classes.okButton}
                                disabled={disableOkButton}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (onOkButtonClick) {
                                        onOkButtonClick();
                                    }
                                }}
                            >
                                {okButton || t("main_modal.ok_button")}
                            </Button>
                        </div>
                    </>
                )}
                {showFooter && footer && (
                    <>
                        {showFooterDivider && <Divider className={classes.footerDivider} />}
                        {footer}
                    </>
                )}
            </Box>
        </Modal>
    );
};

export default MainModal;
